import { render, staticRenderFns } from "./DoctorPatientList.vue?vue&type=template&id=76970c64&"
import script from "./DoctorPatientList.vue?vue&type=script&lang=js&"
export * from "./DoctorPatientList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports